import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isDirty } from 'redux-form';
import { browserHistory } from 'react-router';
import * as clevertapLibraryBrand from 'clevertap/library/brand';
import { handleAccessBrandMenu } from 'reducers/inventoryFeatures/actions';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { push } from 'react-router-redux';
import {
  brandsPageRequest,
  deleteBrand,
  cancelDelete,
} from 'actions/library/brand';
import { askConfirmAction } from 'actions/confirm-action';
import NoDataAndLoading from 'components/NoDataAndLoading';
import withFeatureFlags from 'hocs/withFeatureFlags';
import List from './List';
import ActionBar from './ActionBar';
import BrandDetail from './BrandDetail';

class Brand extends Component {
  render() {
    const {
      showDeleteModal,
      deletedBrand,
      openRightColumn,
      showLoadingSpinnerPage,
      brands,
    } = this.props;
    const brandName = deletedBrand ? deletedBrand.name : '';
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={brands.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Create Brands"
              linkUrl="https://mokaposhelp.zendesk.com/hc/en-us/articles/115005507608-Create-Brands"
            />
            <List />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <BrandDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        {deletedBrand &&
          !deletedBrand.is_reward_brand &&
          !deletedBrand.is_point_gain_brand && (
            <LibraryDeleteModal
              showDeleteModal={showDeleteModal}
              onHide={this._onHideModal}
              title="Brand"
              name={brandName}
              onDelete={this._onDelete}
            />
          )}
        {deletedBrand &&
          (deletedBrand.is_reward_brand ||
            deletedBrand.is_point_gain_brand) && (
            <LibraryDeleteModal
              showDeleteModal={showDeleteModal}
              onHide={this._onHideModal}
              title="Loyalty Program Brand"
              description="You can’t use this brand in your loyalty program if you delete it. Are you sure you still want to delete?"
              name={brandName}
              onDelete={this._onDelete}
            />
          )}
        <ConfirmActionModal />
      </PageWrapper>
    );
  }

  componentDidMount() {
    this.props.dispatch(handleAccessBrandMenu());
    this.props.dispatch(brandsPageRequest());
    browserHistory.listenBefore(location => {
      if (this.props.isDirtyBrand && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  _onHideModal = () => {
    this.props.dispatch(cancelDelete());
  };

  _onDelete = () => {
    const { dispatch, brands, deletedBrand } = this.props;
    clevertapLibraryBrand.libraryBrandDelete({
      name: deletedBrand.name,
    });
    dispatch(deleteBrand(deletedBrand.id, brands));
  };

  _onSubmit = values => {
    const { brands, items } = this.props;
    let name = null;
    const itemName = [];
    brands.forEach(brand => {
      if (brand.id === values.id) name = brand.name;
    });
    values.itemIds.forEach(id => {
      items.forEach(item => {
        if (`${id}` === `${item.id}`) {
          itemName.push(item.name);
        }
      });
    });
    clevertapLibraryBrand.libraryBrandAssignToItems({
      name,
      itemNames: itemName,
    });
  };
}

function mapStateToProps(state) {
  const {
    brands,
    showDeleteModal,
    deletedBrand,
    openRightColumn,
  } = state.library.brand;
  const isDirtyBrand = isDirty('brand')(state);
  const { nextAction } = state.confirmAction;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const { listInventoryFeature } = state.inventoryFeatures;
  return {
    brands,
    showDeleteModal,
    deletedBrand,
    isDirtyBrand,
    listInventoryFeature,
    nextAction,
    openRightColumn,
    showLoadingSpinnerPage,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(Brand);

const mapFlagsToProps = flags => ({
  ecommerceAttributes: flags.ecommerceAttributes,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
